const Benefits = ({ BenefitsInfo }) => {
  return (
    <div className="bg-[#F2F2F2]">
      <div className="custom-container py-[87px]">
        <div className="font-[Rockwell] 2xl:text-[40px] xl:text-[35px] lg:text-[30px] md:text-[25px] sm:text-[20px] text-[17px] font-extrabold border-b-[3px] border-[#7ABF5B] text-[#000]">
          BENEFITS
        </div>

        <div className="grid lg:grid-cols-3 md:grid-cols-2 grid-cols-1  gap-16 mt-[43px]">
          {BenefitsInfo?.map((item) => {
            return (
              <div>
                <div className="font-[Roboto] font-extrabold 2xl:text-[30px] xl:text-[25px] lg:text-[23px] sm:text-[20px] text-[16px] text-[#000]">
                  {item?.title}
                </div>
                <div className="font-[Roboto] font-normal 2xl:text-[30px] xl:text-[25px] lg:text-[23px] sm:text-[20px] text-[16px] text-[#000] mt-[25px]">
                  {item?.subTitle}
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};
export default Benefits;
